import { Box } from "@mui/material";
import { styled } from "@mui/system";
import { DRAWER_WIDTH } from "../../../home/HomeDrawer";

export const StatusIndicator = styled(Box)(() => ({
  borderRadius: "100%",
  width: "20px",
  height: "20px",
  zIndex: 2,
}));

export const Connector = styled(Box)(() => ({
  position: "absolute",
  left: "50%",
  height: "2px",
  width: "67px",
}));

export const TalentActionBannerContainer = styled(Box)(() => ({
  display: "flex",
  gap: "8px",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: "0 1rem",
  height: "68px",
  position: "fixed",
  bottom: 0,
  left: DRAWER_WIDTH,
  right: 0,
  zIndex: 10,
  boxSizing: "border-box",
  backgroundColor: "#fff",
  boxShadow:
    "0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 1px 8px rgba(0, 0, 0, 0.12)",
}));
